import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type { EditRoleRequest, Role } from '../../../../typings/api';

import { rolesQueryKey } from './useRoles';

type UpdateRoleParams = EditRoleRequest & { id: number };

async function updateRole({ id, ...role }: UpdateRoleParams): Promise<Role> {
  const response = await put<EditRoleRequest, Role>(`/api/roles/${id}`, role);
  return response.data as Role;
}

/**
 * Update a custom role.
 */
export default function useUpdateRole() {
  return useToastedMutation({
    mutationFn: updateRole,
    successToastMessage: 'Role updated successfully',
    errorToastMessage: 'Failed to update role',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: rolesQueryKey });
    },
  });
}
